import { render, staticRenderFns } from "./PreviewImages.vue?vue&type=template&id=b0768f10&"
import script from "./PreviewImages.vue?vue&type=script&lang=js&"
export * from "./PreviewImages.vue?vue&type=script&lang=js&"
import style0 from "./PreviewImages.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports